<script setup lang="ts">
import { ref } from 'vue';
import { MlSkeletonTable } from 'design.zorgdomein';

const props = withDefaults(
    defineProps<{
        delay?: number;
    }>(),
    {
        delay: 300
    }
);
const visible = ref(false);

// Wait {delay}ms before making the loading graphic visible.
// If whatever other async operation completes within that timeframe,
// then whichever parent component invoked the loading component will
// presumably re-render without the loading component.
// This helps prevent the loading graphic from too briefly "flashing" on the screen
// causing an undesirable flicker for users.
setTimeout(() => {
    visible.value = true;
}, props.delay);

defineExpose({
    visible
});
</script>

<template>
    <div class="content">
        <div class="container">
            <div class="row">
                <div class="col">
                    <MlSkeletonTable v-if="visible" />
                </div>
            </div>
        </div>
    </div>
</template>
